export const CUSTOMER_TYPE_MAP = {
    patient: { code: "J72", name: "患者"},
    hospital: { code: "ZZZ", name: "医療機関"},
}



// WEBPACK FOOTER //
// ./src/utils/customer.js